<template>
<div>
  <div class="mobile-funnel-container m-t-20">
    <ul class="mobile-funnel show">
      <template v-if="($f7route.path.includes('compromiso') || storage.montura) && storage.diamante === ''">
        <li class="Ring" style="width: 28%"
          :class="{
            active: $f7route.path.includes('compromiso')
          }"
        >
          <img v-if="storage.montura !== ''" src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <template v-if="storage.montura">
            <div :class="{ 'text-white': $f7route.path.includes('compromiso') }" @click="filtro='montura'"></div>
          </template>
          <template v-else>
            <f7-link href="/compromiso/">
              <div ></div>
            </f7-link>
          </template>
        </li>
        <li class="Diamond" style="width:33%; padding-left: 15px;"
          :class="{
            active: $f7route.path.includes('diamantes')
          }"
        >
          <img v-if="storage.diamante !== ''" src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <template v-if="storage.diamante">
            <div :class="{ 'text-white': $f7route.path.includes('diamantes') }" @click="filtro='diamante'"></div>
          </template>
          <template v-else>
            <f7-link href="/diamantes/">
              <div></div>
            </f7-link>
          </template>
        </li>
      </template>
      <template v-else>
        <li class="Diamond" style="width:28%;"
          :class="{
            active: $f7route.path.includes('diamantes')
          }"
        >
          <img v-if="storage.diamante !== ''" src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <template v-if="storage.diamante">
            <div :class="{ 'text-white': $f7route.path.includes('diamantes') }" @click="filtro='diamante'"></div>
          </template>
          <template v-else>
            <f7-link href="/diamantes/">
              <div></div>
            </f7-link>
          </template>
        </li>
        <li class="Ring" style="width:33% padding-left: 15px;"
          :class="{
            active: $f7route.path.includes('compromiso')
          }"
        >
          <img v-if="storage.montura !== ''" src="assets/img/otros/check.png" alt="" width="18" style="position: absolute; right: 0; top: 10px;">
          <template v-if="storage.montura">
            <div :class="{ 'text-white': $f7route.path.includes('compromiso') }" @click="filtro='montura'"></div>
          </template>
          <template v-else>
            <f7-link href="/compromiso/">
              <div ></div>
            </f7-link>
          </template>
        </li>
      </template>

      <li class="Complete complete">
        <f7-link :href="storage.diamante && storage.montura ? '/completar/' : ''">
          <div></div>
        </f7-link>
      </li>
    </ul>
  </div>

  <template v-if="montura">
    <f7-sheet class="h-250 sheet-border-radius-15 m-b-20" :opened="filtro === 'montura'" @sheet:closed="filtro = ''" style="width:90%; left:5%; border-radius:15px;">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">{{ $helper.str.capitalizar(montura.name) || '' }}</span>
        </div>
        <!-- <div class="right">
          <f7-link class="text-white" sheet-close>eliminar</f7-link>
        </div> -->
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col width="35">
            <img class="wd-100" :src="`//madai.mx/assets/images/${montura.image}`" alt="">
          </f7-col>
          <f7-col width="65" class="fs-15">
            <f7-row>
              <span class="bold">Laterales</span> {{ $helper.str.capitalizar(montura.cuts_lateral_stone) }}
            </f7-row>
            <f7-row>
              <span class="bold">Claridad</span> {{ montura.m_clarity }}
            </f7-row>
            <f7-row>
              <span class="bold">Color</span> {{ $helper.str.capitalizar(montura.color) }}
            </f7-row>
            <f7-row>
              <span class="bold">Peso</span> {{ montura.m_weight }}
            </f7-row>
            <f7-row>
              <span class="bold">Montura</span> {{ $helper.str.formatearMoneda(montura.price) }}
            </f7-row>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <template v-if="storage.diamante">
            <f7-col width="20" />
            <f7-col width="60">
              <f7-button href="/compromiso/" @click="storage.montura = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
            </f7-col>
            <f7-col width="20" />
          </template>
          <template v-else>
            <f7-col>
              <f7-button href="/compromiso/" @click="storage.montura = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
            </f7-col>
            <f7-col>
              <f7-button href="/diamantes/" class="text-white" small fill raised sheet-close>Agregar Diamante</f7-button>
            </f7-col>
          </template>
        </f7-row>
      </f7-page-content>
    </f7-sheet>
  </template>

  <template>
    <f7-sheet class="h-270 sheet-border-radius-15 m-b-20" :opened="filtro === 'diamante'" @sheet:closed="filtro = ''" style="width:90%; left:5%; border-radius:15px;">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">ID {{ $helper.str.capitalizar(diamante.ItemID) || '' }}</span>
        </div>
        <!-- <div class="right">
          <f7-link class="text-white" sheet-close>eliminar</f7-link>
        </div> -->
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col width="35" class="p-t-20">
            <img class="wd-100" :src="`//madai.mx/img/diamond/redondo.png`" alt="">
          </f7-col>
          <f7-col width="65" class="fs-15">
            <f7-row>
              <span class="bold">Forma</span> {{ $helper.str.capitalizar(diamante.Cut) }}
            </f7-row>
            <f7-row>
              <span class="bold">Carat</span> {{ diamante.Carat }}
            </f7-row>
            <f7-row>
              <span class="bold">Claridad</span> {{ diamante.Clarity }}
            </f7-row>
            <f7-row>
              <span class="bold">Color</span> {{ diamante.Color }}
            </f7-row>
            <f7-row>
              <span class="bold">Corte</span> {{ diamante.MakeCutGrade }}
            </f7-row>
            <f7-row>
              <span class="bold">Medida</span> {{ diamante.Measurements }}
            </f7-row>
            <f7-row>
              <span class="bold">Precio</span> {{ $helper.str.formatearMoneda(diamante.Price) }}
            </f7-row>
          </f7-col>
        </f7-row>
        <f7-row class="p-5 p-l-15 p-r-15">
          <template v-if="storage.montura">
            <f7-col width="20" />
            <f7-col width="60">
              <f7-button href="/diamantes/" @click="storage.diamante = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
            </f7-col>
            <f7-col width="20" />
          </template>
          <template v-else>
            <f7-col>
              <f7-button href="/diamantes/" @click="storage.diamante = ''" class="text-white" color="blue" small fill raised sheet-close>Cambiar</f7-button>
            </f7-col>
            <f7-col>
              <f7-button href="/compromiso/" class="text-white" small fill raised sheet-close>Agregar Montura</f7-button>
            </f7-col>
          </template>
        </f7-row>
      </f7-page-content>
    </f7-sheet>
  </template>
</div>
</template>

<script>
export default {
  data () {
    return {
      filtro: '',
      montura: {},
      diamante: {}
    }
  },
  watch: {
    storage: {
      handler (val) {
        this.init()
      },
      deep: true
    }
  },
  methods: {
    async init () {
      if (this.storage.montura !== '') {
        this.montura = await this.$api.catalogo.detallesCompromiso(this.storage.montura)
      } else {
        this.montura = {}
      }

      if (this.storage.diamante !== '') {
        this.diamante = await this.$api.catalogo.detallesDiamante(this.storage.diamante)
      } else {
        this.diamante = {}
      }
    }
  },
  created () {
    this.init()
  }
}
</script>

<style scoped>
.mobile-funnel{clear:both;height:33px;line-height:33px;margin:0;table-layout:fixed;text-align:center;width:100%;box-sizing:border-box;border:2px solid #111427;border-radius:4px;}
.mobile-funnel.show{display:table!important;margin-bottom:.5em;z-index:10;position:relative;}
.mobile-funnel>li .dropdown{display:none;}
.mobile-funnel>li{cursor:pointer;display:table-cell;height:100%;position:relative;}
.mobile-funnel>li.active{background-color:#293061;color:#fff;}
.mobile-funnel>li.Ring div::before{content:"Montura"; font-size: 12px; text-transform: uppercase; font-weight: bold; }
.mobile-funnel>li.Diamond div::before{content:"Diamante"; font-size: 12px; text-transform: uppercase; font-weight: bold; }
.mobile-funnel>li.complete div::before,.mobile-funnel>li.Complete div::before{content:"Completar"; font-size: 12px; text-transform: uppercase; font-weight: bold; }
.mobile-funnel>li div::before{content:attr(step);}
.mobile-funnel>li:not(:last-child)::before{border-color:transparent transparent transparent #111427;border-style:solid;border-width:18px 0 18px 15px;content:"";position:absolute;right:-15px;top:-1px;z-index:9;}
.mobile-funnel>li:not(:last-child)::after{border-color:transparent transparent transparent #fff;border-style:solid;border-width:16px 0 16px 13px;content:"";position:absolute;right:-13px;top:1px;z-index:9;}
.mobile-funnel>li.active:not(:last-child)::after{border-color:transparent transparent transparent #293061;}
a{text-decoration:none;color:inherit;}
.mobile-funnel-container{width:95%;margin:0 auto;}
ul{padding:0;list-style:none;}
li,ul{padding:0;margin:0;}
li,ul{list-style:none;}
a{text-decoration:none;}
:focus{outline:none;}
</style>
